import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["typeSelect", "fieldGroup"]

  connect() {
    this.showFieldsForType(this.typeSelectTarget.value)
  }

  switchType() {
    this.showFieldsForType(this.typeSelectTarget.value)
  }

  showFieldsForType(type) {
    this.fieldGroupTargets.forEach(group => {
      group.classList.toggle("hidden", group.dataset.entryType !== type)
    })
  }
}
